module.exports = __webpack_public_path__ + "img/plaid_logo.79a78317.png";